<template>
  <AGTextField
    ref="inputRef"
    v-model="formattedValue"
    :disabled="disabled"
    :hint="hint"
    :label="label"
    :maxlength="maxlength"
    :placeholder="placeholder"
    :readonly="readonly"
    :rules="rules"
    :error-messages="errorMessages"
  />
</template>

<script>
import AGTextField from '@/components/common/AGTextField.vue';
import { computed, watch } from 'vue';
import { CurrencyDisplay, useCurrencyInput } from 'vue-currency-input';

export default {
  components: { AGTextField },
  props: {
    modelValue: {
      type: [Number, String],
      default: '',
    },

    label: {
      type: String,
      default: '',
    },

    placeholder: {
      type: String,
      default: '',
    },

    rules: {
      type: Array,
      default: () => [],
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    hint: {
      type: String,
      default: undefined,
    },

    precision: {
      type: Number,
      default: 0,
    },

    hideCurrency: {
      type: Boolean,
      default: false,
    },

    readonly: {
      type: Boolean,
      default: false,
    },

    maxlength: {
      type: Number,
      default: undefined,
    },

    min: {
      type: Number,
      default: undefined,
    },

    max: {
      type: Number,
      default: undefined,
    },

    errorMessages: {
      type: String,
      default: undefined,
    },
  },

  setup(props) {
    const options = computed(() => ({
      locale: 'pt-BR',
      currency: 'BRL',
      currencyDisplay: props.hideCurrency ? CurrencyDisplay.hidden : CurrencyDisplay.symbol,
      precision: props.precision,
      hideCurrencySymbolOnFocus: false,
      hideGroupingSeparatorOnFocus: false,
      hideNegligibleDecimalDigitsOnFocus: false,
      autoDecimalDigits: true,
      autoSign: true,
      useGrouping: props.precision > 0,
      accountingSign: true,
      valueRange: {
        min: props.min,
        max: props.max,
      },
    }));

    const { inputRef, formattedValue, setValue, setOptions } = useCurrencyInput(options.value);

    watch(
      () => props.modelValue,
      (value) => {
        setValue(value);
      },
    );

    watch(
      () => props.hideCurrency,
      () => setOptions(options.value),
    );

    watch(
      () => props.precision,
      () => setOptions(options.value),
    );
    return { inputRef, formattedValue };
  },
};
</script>
